/* mm-original.js — „Nur das Original": Warnung vor Fälschungen, mit Echtheits-Bühne.
 *
 * 29.08.2026, Mert: „Sag was zu gefälschten Produkten … Wichtig: Die
 * Aussenverpackung kann original sein, aber der Inhalt gefälscht und ungeprüft."
 *
 * 29.08.2026, Mert zur ersten Fassung: „Ich mach hier Bilder einblenden,
 * ausblenden, Animation. Das sieht noch zu sehr nach KI aus. Noch viel zu
 * trocken. Schöne, flüssige Animation ohne Fehler. Einblenden, ausblenden,
 * Hologramme zeigen, weil es geht ja hier um das Thema Original. Von der Seite
 * zeigen und so weiter."
 *
 * DIE BÜHNE
 *   Drei echte Produktbilder wechseln sich ab. Jedes dreht beim Kommen aus der
 *   Seitenlage in die Front (rotateY -30° -> 0°) und dreht beim Gehen weiter
 *   weg - das ist das „von der Seite zeigen". Darüber läuft ein
 *   Hologramm-Schimmer und eine Prüf-Linie.
 *
 * WARUM GERADE HOLOGRAMM
 *   Die Packung trägt selbst einen Sicherheitsstreifen mit der Aufschrift
 *   ORIGINAL SECURITY - ein echtes Hologramm auf echtem Karton. Der Schimmer
 *   auf der Bühne ist also kein Effekt um des Effekts willen, sondern zeigt
 *   genau das Merkmal, an dem man das Original erkennt.
 *
 * BILDER - bewusste Auswahl
 *   Genommen: die drei FREIGESTELLTEN Packungs-/Stickbilder (Standard-Box,
 *   Standard-Stick, Strawberry-Box). Sie stehen auf durchsichtigem Grund, haben
 *   keinen eingebauten Text, der zerschnitten werden könnte, und sitzen deshalb
 *   in jedem Format vollständig im Bild (`object-fit:contain`, feste Regel
 *   21.08.2026).
 *   NICHT genommen: die echten Handyfotos vom Hologramm-Siegel
 *   (Produktbilder/Echte Fotos/Box/Standard/04 …). Inhaltlich wären sie der
 *   beste Beleg, aber sie sind unscharf und zeigen im Hintergrund eine
 *   Küchenplatte - das hätte die Sektion billig gemacht. Der Sicherheitsstreifen
 *   ist auf den freigestellten Bildern ohnehin deutlich zu sehen.
 *
 * BEWEGUNG PAUSIERT (feste Regel 23.08.2026)
 *   Ein IntersectionObserver hält die Uhr an, sobald die Sektion aus dem Bild
 *   ist, und `document.hidden` hält sie an, sobald der Tab weg ist. Die
 *   CSS-Animationen werden über eine Klasse mitangehalten - unsichtbar laufen
 *   lassen kostet genauso viel Rechenzeit wie sichtbar.
 *
 * FARBEN
 *   Rot bleibt Akzentlinie und Signalwort, keine Fläche (feste Regel: kein
 *   rotes KI-Design). Pink kommt nicht als Textfarbe vor. Der Schimmer ist
 *   bewusst schillernd - das ist die Farbe eines Hologramms, nicht eine vierte
 *   Markenfarbe: er läuft nur 1,6 Sekunden je Schritt und liegt bei 35 %.
 */
(function () {
  'use strict';

  var ROT = '#E5142A';
  var TAKT = 4200;      /* wie lange ein Bild steht */
  var CDN = 'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/';

  var BILDER = [
    { d: 'mm-orig-box-standard.png?v=1788004158&width=580', w: 580, h: 382,
      b: 'Magic Milk FOR X5 Standard, Packung von vorne',
      t: 'ORIGINAL SECURITY — der Streifen auf jeder Packung' },
    { d: 'mm-orig-stick-standard.png?v=1788004158&width=340', w: 340, h: 901,
      b: 'Magic Milk FOR X5 Stick, einzeln versiegelt',
      t: 'Versiegelt \u2014 und die Pr\u00fcflinie zeigt, was drin ist',
      /* Die Pruef-Linie deckt beim Darueberlaufen das Innere auf. Der Stick
         selbst bleibt dabei unangetastet - siehe Kommentar bei .mmORoentgen. */
      /* 29.08.2026, Mert: „nein das pulver ist weiss/hell beige" - die erste
         Fuellung war zu dunkel und zu erdig. Jetzt heller Grundton mit sehr
         zurueckhaltendem Korn und nur wenigen, ebenfalls hellen Teilchen. */
      r: 'mm-orig-stick-roentgen-hell.png?v=1788018781&width=340' },
    /* 29.08.2026, Merts Korrektur: „das sind nach ki aus die schrift, verrutscht,
       man erkennt das es ki ist. nimm eine echte bildaufnahme und blende die ein,
       mach es in studio version, aber immernoch echte aufnahme … und mach dabei
       kleine texte mit linien die auf den siegel zeigen, wie bei geldscheinen."

       ER HATTE RECHT. Die vorige Fassung war das Verpackungs-Artwork, dreifach
       hochgerechnet und nachgeschärft - dabei verrutscht feine Schrift, und
       genau das sieht nach Maschine aus.

       JETZT: eine ECHTE Aufnahme.
       Quelle: `Echte Fotos/Box/Standard/04 Box geschlossen mit Hologramm-Siegel.jpg`
       (4032x3024). Der Streifen lag um 18,5 Grad gekippt und kopfüber im Bild -
       der Winkel ist aus den farbigen Hologramm-Etiketten selbst gerechnet
       (Hauptachse der Punktwolke), dann aufgerichtet, um 180 Grad gedreht und
       eng zugeschnitten.
       Studio-Anmutung ohne Neuzeichnen: Weißabgleich über einen Graupunkt am
       Karton (Blitzlicht war kühl), Kontrast +14 %, Farbe +10 %, sanftes
       Schärfen und eine weiche Vignette. Kein Pixel ist erfunden.

       DIE ZEIGER: vier kurze Beschriftungen mit Linie auf die Merkmale - wie die
       Erklärungen zu Sicherheitsmerkmalen auf Geldscheinen. Sie blenden
       nacheinander ein, sobald diese Stufe dran ist. */
    { d: 'mm-siegel-echt.png?v=1788028352&width=520', w: 520, h: 2162,
      b: 'Nahaufnahme des ORIGINAL-SECURITY-Hologramms auf der Magic-Milk-Packung',
      t: 'Das Siegel aus der N\u00e4he \u2014 daran erkennst du es',
      zeiger: [
        { y: 7,  s: 're', x: 'FOR X5 \u2014 Herstellerzeichen' },
        { y: 31, s: 'li', x: 'ORIGINAL SECURITY im Hologramm' },
        { y: 57, s: 're', x: 'Feines Wellenraster' },
        { y: 79, s: 'li', x: 'Wiederholt sich \u00fcber den Streifen' }
      ] },
    { d: 'mm-orig-box-strawberry.png?v=1788004158&width=520', w: 520, h: 761,
      b: 'Magic Milk FOR X5 Strawberry, Packung von vorne',
      t: 'Gleiche Prüfung, gleiche Herkunft — jede Sorte' }
  ];

  var ruhig = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = [
    '#mmOrig{width:100%;box-sizing:border-box;background:#151013;color:#F3E9EC;',
    'padding:clamp(30px,5vw,54px) 0;position:relative;overflow:hidden}',
    '#mmOrig *{box-sizing:border-box}',
    '#mmOrigInnen{max-width:760px;margin:0 auto;padding:0 20px}',

    '#mmOrig .mmOAuge{display:inline-flex;align-items:center;gap:7px;',
    'font-family:"Manrope",system-ui,sans-serif;font-size:.6rem;font-weight:800;',
    'letter-spacing:.16em;text-transform:uppercase;color:' + ROT + ';margin:0 0 10px}',
    '#mmOrig .mmOAuge:before{content:"";width:16px;height:2px;background:' + ROT + '}',

    '#mmOrig h2{font-family:"Bricolage Grotesque","Manrope",sans-serif;font-weight:800;',
    'font-size:clamp(1.5rem,5.2vw,2.2rem);line-height:1.08;margin:0 0 12px;',
    'letter-spacing:-.01em;color:#F3E9EC}',

    '#mmOrig .mmOVor{font-family:"Manrope",system-ui,sans-serif;font-size:.92rem;',
    'line-height:1.6;color:rgba(243,233,236,.72);margin:0 0 22px}',

    /* ---------- Echtheits-Buehne ---------- */
    /* Hoechstbreite statt halber Fensterbreite (feste Regel 22.08.2026):
       am Handy fuellt sie die Spalte, am Rechner bleibt sie bei 360px. */
    '#mmOrig .mmOBuehne{width:min(100%,360px);margin:0 auto 24px}',
    '#mmOrig .mmOFeld{position:relative;width:100%;aspect-ratio:4/5;',
    'border-radius:18px;overflow:hidden;background:',
    'radial-gradient(120% 90% at 50% 8%,rgba(243,233,236,.07),transparent 62%),#191216;',
    'border:1px solid rgba(243,233,236,.10);perspective:1000px;',
    'perspective-origin:50% 45%}',
    /* Fallback fuer Browser ohne aspect-ratio */
    '@supports not (aspect-ratio:4/5){#mmOrig .mmOFeld{height:0;padding-bottom:125%}}',

    /* schillernder Schein hinter dem Produkt - dreht sehr langsam */
    '#mmOrig .mmOAura{position:absolute;inset:-12%;pointer-events:none;opacity:.26;',
    'will-change:transform;',
    'background:conic-gradient(from 0deg,rgba(90,200,255,.0),rgba(90,200,255,.55),',
    'rgba(180,130,255,.45),rgba(120,255,190,.40),rgba(255,190,120,.35),rgba(90,200,255,.0));',
    'filter:blur(38px);animation:mmODreh 26s linear infinite}',
    '@keyframes mmODreh{to{transform:rotate(360deg)}}',

    /* die Bilder liegen uebereinander und blenden sich ab */
    '#mmOrig .mmOHalt{position:absolute;left:8%;top:7%;width:84%;height:86%;',
    'opacity:0;transform-style:preserve-3d;will-change:transform,opacity;',
    'transform:rotateY(-30deg) translateZ(-40px) scale(.9);',
    /* Das gehende Bild ist schneller weg, als das kommende da ist. Sonst liegen
       beide gleichzeitig bei halber Deckkraft uebereinander und es matscht. */
    'transition:opacity .55s cubic-bezier(.4,0,.6,1),',
    'transform 1s cubic-bezier(.22,.61,.36,1)}',
    '#mmOrig .mmOHalt.mmDa{opacity:1;transform:rotateY(0deg) translateZ(0) scale(1);',
    'transition:opacity .8s cubic-bezier(.22,.61,.36,1) .28s,',
    'transform 1.15s cubic-bezier(.22,.61,.36,1) .12s}',
    '#mmOrig .mmOHalt.mmWeg{opacity:0;transform:rotateY(26deg) translateZ(-30px) scale(.95)}',
    '#mmOrig .mmOBild{width:100%;height:100%;object-fit:contain;',
    'filter:drop-shadow(0 22px 34px rgba(0,0,0,.55))}',
    /* Das stehende Bild wiegt sich ruhig weiter - ein voellig starres Bild
       zwischen zwei Wechseln ist genau das, was trocken wirkt. */
    '#mmOrig .mmOHalt.mmDa .mmOBild{animation:mmOWiegen 9s ease-in-out infinite}',
    '@keyframes mmOWiegen{0%,100%{transform:rotateY(-3.5deg) translateZ(0)}',
    '50%{transform:rotateY(3.5deg) translateZ(8px)}}',

    /* Hologramm-Schimmer: laeuft einmal je Schritt schraeg ueber das Produkt.
       screen hellt nur auf - auf dunklem Grund sieht das aus wie Licht,
       das sich in einer Folie bricht. */
    '#mmOrig .mmOSchimmer{position:absolute;inset:-20% -60%;pointer-events:none;',
    'will-change:transform,opacity;',
    'mix-blend-mode:screen;opacity:0;transform:translateX(-120%) skewX(-14deg);',
    'background:linear-gradient(90deg,transparent 0%,rgba(255,255,255,.00) 34%,',
    'rgba(120,220,255,.42) 43%,rgba(255,255,255,.55) 50%,rgba(200,140,255,.42) 57%,',
    'rgba(140,255,200,.30) 64%,transparent 82%)}',
    '#mmOrig .mmOSchimmer.mmLauf{animation:mmOSchein 1.7s cubic-bezier(.4,0,.25,1) 1}',
    '@keyframes mmOSchein{0%{opacity:0;transform:translateX(-120%) skewX(-14deg)}',
    '18%{opacity:1}82%{opacity:1}',
    '100%{opacity:0;transform:translateX(120%) skewX(-14deg)}}',

    /* ---------- Siegel mit Zeigern, wie bei Geldscheinen ---------- */
    /* Das Siegelbild ist sehr schmal (520x2162). Damit die Zeiger genau auf die
       Merkmale treffen, sitzt es in einer eigenen Box mit festem Verhaeltnis -
       so beziehen sich alle Prozentangaben auf das Bild und nicht auf die
       Buehne. Die Beschriftungen bleiben innerhalb von .mmOHalt, sonst wuerden
       sie an der Buehnenkante abgeschnitten (feste Regel). */
    '#mmOrig .mmOHalt.mmOMitZeiger .mmOBild{width:auto;height:100%;',
    'margin:0 auto;display:block}',
    '#mmOrig .mmOZ{position:absolute;width:31%;pointer-events:none;',
    'font-family:"Manrope",system-ui,sans-serif;font-size:.56rem;line-height:1.3;',
    'color:rgba(243,233,236,.82);opacity:0;transform:translateY(4px)}',
    '#mmOrig .mmOZ.li{left:0;text-align:right}',
    '#mmOrig .mmOZ.re{right:0;text-align:left}',
    /* Linie plus Punkt: die Linie laeuft von der Textkante bis an das Bild. */
    '#mmOrig .mmOZ:before{content:"";position:absolute;top:50%;height:1px;',
    'width:14px;background:rgba(243,233,236,.45)}',
    '#mmOrig .mmOZ:after{content:"";position:absolute;top:50%;width:5px;height:5px;',
    'margin-top:-2px;border-radius:50%;background:' + ROT + ';',
    'box-shadow:0 0 0 3px rgba(229,20,42,.22)}',
    '#mmOrig .mmOZ.li:before{left:100%}',
    '#mmOrig .mmOZ.li:after{left:calc(100% + 14px)}',
    '#mmOrig .mmOZ.re:before{right:100%}',
    '#mmOrig .mmOZ.re:after{right:calc(100% + 14px)}',
    /* Erst wenn die Stufe steht, blenden sie nacheinander ein. */
    '#mmOrig .mmOHalt.mmDa .mmOZ{animation:mmOZein .5s cubic-bezier(.22,.61,.36,1) both;',
    'animation-delay:calc(.7s + var(--i,0) * .22s)}',
    '@keyframes mmOZein{to{opacity:1;transform:none}}',

    /* ---------- Roentgen-Blick in den Stick ----------
       29.08.2026, Mert: „mach so eine Roentgen Ansicht ... Auch dieses Pulver da
       drin soll man sehen bei dem Stick. Sehr wichtig, aber das Bild unveraendert
       lassen. Also das Produkt, so wie es aussieht, so soll es bleiben. Nur innen
       drin soll man sehen." · „mach es realistisch"

       SO IST ES GELOEST
         Das echte Stick-Foto bleibt die Grundschicht und wird NICHT angefasst -
         kein Pixel der Verpackung ist veraendert (feste Regel: Magic-Milk-
         Produktbilder nie von einer KI zeichnen lassen). Darueber liegt
         deckungsgleich eine zweite Ebene, die nur die FUELLUNG zeigt: feines
         Mischpulver, begrenzt auf die Kammer zwischen den beiden Riffelnaehten.
         Sichtbar wird sie ausschliesslich in einem schmalen Fenster, das mit der
         Pruef-Linie mitwandert - dort schaut man in den Stick hinein, ueberall
         sonst sieht man die Packung wie immer.

       WARUM KEIN KI-BILD
         Ein generiertes Stick-Bild haette die Verpackung neu gezeichnet. Die
         Fuellung ist deshalb aus dem Silhouetten-Alphakanal des echten Fotos
         aufgebaut (Rand nach innen versetzt = Folienstaerke, Enden ausgespart =
         Naht) und mit einem Pulver aus Grundton, Klumpen, Korn und einzelnen
         dunkleren Pflanzenteilchen gefuellt.

       Fenster und Linie teilen sich Dauer und Kurve (3,6 s), damit sie nicht
       auseinanderlaufen. `mask-position` statt einer Variablen, weil das in
       jedem Browser laeuft. */
    '#mmOrig .mmORoentgen{position:absolute;left:0;top:0;width:100%;height:100%;',
    'object-fit:contain;pointer-events:none;',
    '-webkit-mask-image:linear-gradient(180deg,transparent 0%,#000 30%,#000 70%,transparent 100%);',
    'mask-image:linear-gradient(180deg,transparent 0%,#000 30%,#000 70%,transparent 100%);',
    '-webkit-mask-size:100% 42%;mask-size:100% 42%;',
    '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;',
    'animation:mmORoen 3.6s cubic-bezier(.5,0,.5,1) infinite}',
    '@keyframes mmORoen{0%{-webkit-mask-position:0 -55%;mask-position:0 -55%}',
    '100%{-webkit-mask-position:0 155%;mask-position:0 155%}}',

    /* Pruef-Linie: wandert ruhig von oben nach unten */
    '#mmOrig .mmOScan{position:absolute;left:0;right:0;top:-22%;height:22%;',
    'pointer-events:none;will-change:transform;',
    'background:linear-gradient(180deg,transparent,rgba(120,220,255,.12) 58%,',
    'rgba(243,233,236,.34) 93%,transparent);',
    'animation:mmOScan 3.6s cubic-bezier(.5,0,.5,1) infinite}',
    '@keyframes mmOScan{0%{transform:translateY(0);opacity:0}',
    '12%{opacity:.9}88%{opacity:.9}100%{transform:translateY(560%);opacity:0}}',

    /* Pruefrahmen-Ecken */
    '#mmOrig .mmOEcke{position:absolute;width:16px;height:16px;pointer-events:none;',
    'border:1.5px solid rgba(243,233,236,.30)}',
    '#mmOrig .mmOEcke.o1{top:12px;left:12px;border-right:0;border-bottom:0}',
    '#mmOrig .mmOEcke.o2{top:12px;right:12px;border-left:0;border-bottom:0}',
    '#mmOrig .mmOEcke.o3{bottom:12px;left:12px;border-right:0;border-top:0}',
    '#mmOrig .mmOEcke.o4{bottom:12px;right:12px;border-left:0;border-top:0}',

    '#mmOrig .mmOUnten{display:flex;align-items:center;justify-content:space-between;',
    'gap:12px;margin:10px 2px 0}',
    '#mmOrig .mmOText{font-family:"Manrope",system-ui,sans-serif;font-size:.72rem;',
    'line-height:1.35;color:rgba(243,233,236,.62);margin:0;flex:1;min-width:0;',
    'transition:opacity .45s ease}',
    '#mmOrig .mmOText.mmStill{opacity:0}',
    '#mmOrig .mmOPunkte{display:flex;gap:6px;flex:0 0 auto}',
    '#mmOrig .mmOPunkt{width:6px;height:6px;border-radius:50%;padding:0;border:0;',
    'background:rgba(243,233,236,.24);cursor:pointer;transition:background .3s ease,',
    'transform .3s ease}',
    '#mmOrig .mmOPunkt.mmAn{background:' + ROT + ';transform:scale(1.35)}',

    /* Der Kernsatz. Er steht bewusst allein und traegt die Sektion. */
    '#mmOrig .mmOKern{border-left:3px solid ' + ROT + ';padding:12px 0 12px 16px;',
    'margin:0 0 22px;font-family:"Manrope",system-ui,sans-serif;font-size:1rem;',
    'line-height:1.5;color:#F3E9EC}',
    '#mmOrig .mmOKern strong{color:#FFFFFF}',

    '#mmOrig .mmOListe{display:grid;gap:10px;margin:0 0 22px;padding:0;list-style:none}',
    '@media(min-width:720px){#mmOrig .mmOListe{grid-template-columns:repeat(3,1fr);gap:12px}}',
    /* 21st.dev-inspiriertes, getoentes Schichtglas: nur die Materialoberflaeche
       der drei Warnkarten. Inhalt, Reihenfolge und Funktion bleiben unveraendert. */
    '#mmOrig .mmOListe li{position:relative;isolation:isolate;overflow:hidden;',
    'background:radial-gradient(circle at 12% 0%,rgba(255,255,255,.15),transparent 44%),',
    'linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,75,126,.035) 56%,',
    'rgba(229,20,42,.025)),rgba(30,21,25,.52);',
    'border:1px solid rgba(255,255,255,.15);border-radius:20px;',
    '-webkit-backdrop-filter:blur(16px) saturate(1.42);',
    'backdrop-filter:blur(16px) saturate(1.42);',
    'box-shadow:0 0 8px rgba(0,0,0,.03),0 2px 6px rgba(0,0,0,.08),',
    'inset 3px 3px .5px -3.5px rgba(255,255,255,.30),',
    'inset -3px -3px .5px -3.5px rgba(255,255,255,.72),',
    'inset 1px 1px 1px -.5px rgba(255,255,255,.35),',
    'inset -1px -1px 1px -.5px rgba(255,255,255,.28),',
    'inset 0 0 6px 6px rgba(255,255,255,.035),',
    'inset 0 0 2px 2px rgba(255,255,255,.045),0 16px 36px rgba(5,2,4,.28);',
    'padding:13px 14px;font-family:"Manrope",system-ui,sans-serif;',
    'font-size:.8rem;line-height:1.45;color:rgba(243,233,236,.80)}',
    '#mmOrig .mmOListe li:before{content:"";position:absolute;inset:0;pointer-events:none;',
    'background:linear-gradient(115deg,rgba(255,255,255,.10),transparent 24% 72%,',
    'rgba(255,255,255,.045));opacity:.78}',
    '#mmOrig .mmOListe b{display:block;color:#F3E9EC;font-size:.85rem;margin:0 0 3px}',
    '@media(prefers-reduced-transparency:reduce){#mmOrig .mmOListe li{background:#1E1519;',
    '-webkit-backdrop-filter:none;backdrop-filter:none}#mmOrig .mmOListe li:before{display:none}}',

    '#mmOrig .mmOFuss{font-family:"Manrope",system-ui,sans-serif;font-size:.74rem;',
    'line-height:1.55;color:rgba(243,233,236,.5);margin:0}',

    /* Nichts laeuft weiter, wenn niemand hinsieht. */
    '#mmOrig.mmSchlaeft .mmOAura,#mmOrig.mmSchlaeft .mmOScan,',
    '#mmOrig.mmSchlaeft .mmOSchimmer,#mmOrig.mmSchlaeft .mmOBild,',
    '#mmOrig.mmSchlaeft .mmORoentgen{animation-play-state:paused}',

    '@media(prefers-reduced-motion:reduce){#mmOrig .mmOAura,#mmOrig .mmOScan,',
    '#mmOrig .mmOSchimmer{animation:none;opacity:0}',
    '#mmOrig .mmOBild{animation:none}',
    '#mmOrig .mmORoentgen{animation:none;opacity:0}',
    '#mmOrig .mmOZ{animation:none;opacity:1;transform:none}',
    '#mmOrig .mmOHalt{transition:none}}'
  ].join('');

  function stil() {
    if (document.getElementById('mm-orig-stil')) return;
    var s = document.createElement('style');
    s.id = 'mm-orig-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---------- Bühne steuern ---------- */
  function buehne(wurzel) {
    var bilder = [].slice.call(wurzel.querySelectorAll('.mmOHalt'));
    var punkte = [].slice.call(wurzel.querySelectorAll('.mmOPunkt'));
    var schimmer = wurzel.querySelector('.mmOSchimmer');
    var text = wurzel.querySelector('.mmOText');
    var jetzt = 0, uhr = null, schimmerUhr = null, textUhr = null;

    function zeigen(neu) {
      if (neu === jetzt) return;
      var alt = bilder[jetzt];
      alt.classList.remove('mmDa');
      alt.classList.add('mmWeg');
      /* Die Weg-Klasse muss wieder ab, sonst startet das Bild beim naechsten
         Auftritt aus der falschen Richtung. */
      window.setTimeout(function () { alt.classList.remove('mmWeg'); }, 1200);

      jetzt = neu;
      bilder[jetzt].classList.add('mmDa');
      punkte.forEach(function (p, i) { p.classList.toggle('mmAn', i === jetzt); });

      window.clearTimeout(textUhr);
      text.classList.add('mmStill');
      textUhr = window.setTimeout(function () {
        text.textContent = BILDER[jetzt].t;
        text.classList.remove('mmStill');
      }, 450);

      glanz();
    }

    /* Der Schimmer laeuft erst, wenn das Bild steht - sonst wischt er ins Leere. */
    function glanz() {
      if (ruhig || !schimmer) return;
      window.clearTimeout(schimmerUhr);
      schimmerUhr = window.setTimeout(function () {
        schimmer.classList.remove('mmLauf');
        /* Neustart der Animation erzwingen */
        void schimmer.offsetWidth;
        schimmer.classList.add('mmLauf');
      }, 950);
    }

    function weiter() { zeigen((jetzt + 1) % bilder.length); }

    function starten() {
      wurzel.classList.remove('mmSchlaeft');
      if (ruhig || uhr) return;
      uhr = window.setInterval(weiter, TAKT);
      glanz();
    }
    function anhalten() {
      wurzel.classList.add('mmSchlaeft');
      if (uhr) { window.clearInterval(uhr); uhr = null; }
      window.clearTimeout(schimmerUhr);
    }

    /* erstes Bild sofort */
    bilder[0].classList.add('mmDa');
    punkte[0].classList.add('mmAn');
    text.textContent = BILDER[0].t;

    punkte.forEach(function (p, i) {
      p.addEventListener('click', function () {
        zeigen(i);
        /* nach einem Klick von vorne zaehlen, sonst springt es sofort weiter */
        if (uhr) { window.clearInterval(uhr); uhr = window.setInterval(weiter, TAKT); }
      });
    });

    var sichtbar = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sichtbar = e[0].isIntersecting;
        if (sichtbar && !document.hidden) starten(); else anhalten();
      }, { threshold: 0.15 }).observe(wurzel);
    } else {
      sichtbar = true; starten();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) anhalten();
      else if (sichtbar) starten();
    });
  }

  function bauen() {
    if (document.getElementById('mmOrig')) return true;
    /* Direkt vor die FAQ - dort ist der Kunde ohnehin im Klaeren-Modus. */
    var anker = document.getElementById('mmFaq2') ||
                document.querySelector('.st_faq-wrapper');
    if (!anker || !anker.parentNode) return false;

    stil();
    var s = document.createElement('section');
    s.id = 'mmOrig';
    s.setAttribute('aria-label', 'Bei uns laborgeprüft');
    s.innerHTML =
      '<div id="mmOrigInnen">' +
        '<p class="mmOAuge">Nur das Original</p>' +
        '<h2>Bei uns laborgeprüft.</h2>' +
        '<p class="mmOVor">Unser FOR X5 wurde von einem amtlichen, akkreditierten Labor ' +
        'untersucht. Alle geprüften verbotenen Stoffe lagen unter der Nachweisgrenze.</p>' +

        '<div class="mmOBuehne">' +
          '<div class="mmOFeld">' +
            '<span class="mmOAura"></span>' +
            BILDER.map(function (b, i) {
              return '<span class="mmOHalt' + (b.zeiger ? ' mmOMitZeiger' : '') +
                     '" data-i="' + i + '">' +
                     '<img class="mmOBild" src="' + CDN + b.d + '" ' +
                     'alt="' + b.b + '" loading="lazy" decoding="async" ' +
                     'width="' + b.w + '" height="' + b.h + '">' +
                     (b.r ? '<img class="mmORoentgen" src="' + CDN + b.r + '" alt="" ' +
                            'aria-hidden="true" loading="lazy" decoding="async" ' +
                            'width="' + b.w + '" height="' + b.h + '">' : '') +
                     (b.zeiger ? b.zeiger.map(function (z, n) {
                       return '<span class="mmOZ ' + z.s + '" style="top:' + z.y +
                              '%;--i:' + n + '">' + z.x + '</span>';
                     }).join('') : '') +
                     '</span>';
            }).join('') +
            '<span class="mmOSchimmer"></span>' +
            '<span class="mmOScan"></span>' +
            '<span class="mmOEcke o1"></span><span class="mmOEcke o2"></span>' +
            '<span class="mmOEcke o3"></span><span class="mmOEcke o4"></span>' +
          '</div>' +
          '<div class="mmOUnten">' +
            '<p class="mmOText"></p>' +
            '<div class="mmOPunkte">' +
              BILDER.map(function (b, i) {
                return '<button class="mmOPunkt" type="button" ' +
                       'aria-label="Bild ' + (i + 1) + ' zeigen"></button>';
              }).join('') +
            '</div>' +
          '</div>' +
        '</div>' +

        '<p class="mmOKern"><strong>Die Außenverpackung kann echt aussehen — und der ' +
        'Inhalt trotzdem eine ungeprüfte Kopie sein.</strong> Am Karton allein erkennst ' +
        'du es nicht.</p>' +

        '<ul class="mmOListe">' +
          '<li><b>Der Preis verrät es</b>Auffällig billig ist kein Schnäppchen, sondern ' +
          'das häufigste Zeichen für eine Fälschung.</li>' +
          '<li><b>Ohne Berechtigung, ohne Prüfung</b>Händler ohne Bezug zum Hersteller ' +
          'können keine Laborberichte vorlegen. Von diesen Angeboten distanzieren wir uns.</li>' +
          '<li><b>Keine Haftung von uns</b>Für Ware, die nicht über uns gekauft wurde, ' +
          'übernehmen wir keine Haftung und keine Gewährleistung.</li>' +
        '</ul>' +

        '<p class="mmOFuss">Dir ist etwas untergekommen, das wie Magic Milk aussieht, ' +
        'aber nicht von uns stammt? Schreib uns an info@magicmilk.de — wir gehen dem nach.</p>' +
      '</div>';

    anker.parentNode.insertBefore(s, anker);
    buehne(s);
    return true;
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen() || n > 30) window.clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else {
    versuchen();
  }
  window.addEventListener('load', versuchen);
})();
